const groupPrefixStore = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)
const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.COUPONS)

export const apiCoupons = {
	fetchCoupon: async (actionID: number) => {
		const { data } = await apiCommon<ICoupon>(`${groupPrefix}/${actionID}`, {
			method: 'GET',
		})
		return { data: Coupon(data) }
	},

	storeCoupon: async (
		promotionID: number,
		couponPayload: { code: string; usageLimit: number | null; perCustomerUsageLimit: number | null },
	) => {
		const { data } = await apiCommon<ICoupon>(`${groupPrefixStore}/${promotionID}/coupons`, {
			method: 'POST',
			body: {
				code: couponPayload.code,
				usage_limit: couponPayload.usageLimit,
				per_customer_usage_limit: couponPayload.perCustomerUsageLimit,
			},
		})
		return Coupon(data)
	},

	updateCoupon: async (actionID: number, form: any) => {
		const { data } = await apiCommon<ICoupon>(`${groupPrefix}/${actionID}`, {
			method: 'PUT',
			body: { ...couponToJSON(form) },
		})
		return Coupon(data)
	},

	deleteCoupon: async (actionID: number) =>
		await apiCommon<ICoupon>(`${groupPrefix}/${actionID}`, { method: 'DELETE' }),
}
